import { render } from "./BaseLayout.vue?vue&type=template&id=575eb6f8"
const script = {}

import "./BaseLayout.vue?vue&type=style&index=0&id=575eb6f8&lang=scss"

import exportComponent from "/Users/phoebe/projects/find-bus-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__